import React from 'react';
import { Card } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

export default function VerifyingState() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 text-center">
        <Loader2 className="w-16 h-16 mx-auto mb-4 text-blue-500 animate-spin" />
        <h2 className="text-xl font-semibold mb-2">Verifying Payment</h2>
        <p className="text-gray-600">Please wait while we confirm your payment...</p>
      </Card>
    </div>
  );
}
